<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dialogues">
<div class="section level2" id="oy">
<h2>Oy!</h2>
<table style="width:99%;">
<colgroup>
<col width="7%"/>
<col width="90%"/>
</colgroup>
<thead>
<tr class="header">
<td align="left" colspan="2">M= man W =wo man</td>
</tr>
</thead>
<tbody style="vertical-align: top;">
<tr class="odd">
<td>W:</td>
<td>Did you take out the trash?</td>
</tr>
<tr class="even">
<td>M:</td>
<td><p>I took out the trash.</p>
Did you do the vash?</td>
</tr>
<tr class="odd">
<td>W:</td>
<td>I did the vash.</td>
</tr>
<tr class="even">
<td>M:</td>
<td>Did you do my shirts?</td>
</tr>
<tr class="odd">
<td>W:</td>
<td>If I did the vash, I did your shirts.</td>
</tr>
<tr class="even">
<td>M:</td>
<td>You didn’t mix the shirts with the regular stuff?</td>
</tr>
<tr class="odd">
<td>W:</td>
<td>No, I didn’t mix the shirts with the other stuff.</td>
</tr>
<tr class="even">
<td>M:</td>
<td>You know what happens…</td>
</tr>
<tr class="odd">
<td>W:</td>
<td><p>Never mind that.</p>
Did you go to Schnitz’s Bakery to get the blintzes?</td>
</tr>
<tr class="even">
<td>M:</td>
<td><p>No, I didn’t go to get the blintzes.</p>
When did you supposedly tell me?</td>
</tr>
<tr class="odd">
<td>W:</td>
<td>Vhen you vuz soaking your feet.</td>
</tr>
<tr class="even">
<td>M:</td>
<td>No vonder I forgot!</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?1c2d4a39